/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class MainDrawingController implements angular.IController {
        public mainDrawings: MainDrawingPagedResult;
        public filters: ModelFilterViewModel;
        public erroLoadingData: boolean;
        public fileToken: string;
        public isLoading: boolean;
        public selectedMainDrawing: MainDrawingViewModel;
        

        $onInit = () => { };

        constructor(private $scope: any,
            private buildingService: BuildingService,
            private mainDrawingService: MainDrawingService,
            private drawingExportJobService: DrawingExportJobService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private fileService: FileService,
            private textService: TextService
        ) {
            this.mainDrawings = new MainDrawingPagedResult();
            var vm = this;
            fileService.getFileToken().then((token: string) => vm.fileToken = token);
            this.isLoading = false;
            this.$scope.$on('loadMainDrawings', function (e) {
                vm.loadData(false);
            });
            this.$scope.$on('mainDrawingLoadMore', (e) => {
                vm.loadMore(false);
            });
            function validateFiles(files: Array<any>) {
                for (var i = 0; i < files.length; i++) {
                    if ('.dwf,.dwfx'.indexOf(files[i].name.substring(files[i].name.length - 4).toLowerCase()) == -1) {
                        return false;
                    }
                }
                return true;
            }
            this.$scope.fileSelected = function (sender) {
                if (sender != null && sender.files.length > 0 && validateFiles([sender.files[0]])) {
                    var data = new FormData();
                    data.append("files[]", sender.files[0]);
                    vm.onUploadStart(data).then(() => sender.value = null);
                }
            }
        }

        public selectFile(md: MainDrawingViewModel) {
            this.selectedMainDrawing = md;
            $("#mainDrawingUpload").click();
        }

        public viewExportLog(fileId: string, $event) {
            var vm = this;
            var dialog = {
                controller: MainDrawingController.WarningDialogController(fileId, vm.textService, vm.fileService, vm.$mdDialog),
                controllerAs: 'vm',
                templateUrl: '/app/dialog/warning-list.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog)
        }

        public drawingExportJobStart(md: MainDrawingViewModel): void {
            if (md.secondaryDrawingUrl === PositiveNegative.Positive) {
                return;
            }
            md.secondaryDrawingUrl = PositiveNegative.Positive;
            this.drawingExportJobService.start(md);
        }

        public loadData(sim: boolean) {
            if (this.isLoading) {
                return;
            }
            this.mainDrawings = new MainDrawingPagedResult();
            var vm = this;
            this.erroLoadingData = false;
            this.filters = this.buildingService.getFilters();
            this.isLoading = true;
            this.mainDrawingService.search(this.filters, sim).then((data: MainDrawingPagedResult) => {
                vm.mainDrawings.totalNumberOfPages = data.totalNumberOfPages;
                vm.mainDrawings.totalNumberOfRecords = data.totalNumberOfRecords;
                if (data.totalNumberOfRecords > 10) {
                    vm.mainDrawings.scrollId = data.scrollId;
                }
                else {
                    vm.mainDrawings.scrollId = null;
                }
                vm.mainDrawings.results = data.results;

                vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                vm.isLoading = false;
            }, () => {
                vm.erroLoadingData = true;
                vm.isLoading = false;
            });
        }

        public loadMore(sim: boolean) {
            if (this.isLoading) {
                return;
            }
            if (this.mainDrawings != null && this.mainDrawings.scrollId != null) {
                var vm = this;
                this.erroLoadingData = false;
                this.isLoading = true;
                this.mainDrawingService.scroll(this.mainDrawings.scrollId, sim).then((data: MainDrawingPagedResult) => {
                    if (data == null) {
                        vm.loadData(sim);
                    }
                    else {
                        vm.mainDrawings.totalNumberOfPages = data.totalNumberOfPages;
                        vm.mainDrawings.totalNumberOfRecords = data.totalNumberOfRecords;
                        vm.mainDrawings.scrollId = data.scrollId;
                        if (data.results == null || data.results.length == 0) {
                            vm.mainDrawings.scrollId = null;
                        }
                        else {
                            vm.mainDrawings.results = vm.mainDrawings.results.concat(data.results);
                        }

                        vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                        
                    }
                    vm.isLoading = false;
                }, () => {
                    vm.erroLoadingData = true;
                    vm.isLoading = false;
                });
            }
        }

        public onUploadStart(formData: FormData) {
            var vm = this;
            var spinner = this.showSpinner();
            if (this.selectedMainDrawing == null) {
                return;
            }
            return this.mainDrawingService.uploadImages(this.selectedMainDrawing.associationNumber, this.selectedMainDrawing.departmentNumber, this.selectedMainDrawing.localizer, formData).then((data: MainDrawingViewModel[]) => {
                var drawing = vm.mainDrawings.results.filter(m => m.departmentNumber == vm.selectedMainDrawing.departmentNumber && m.localizer == vm.selectedMainDrawing.localizer);
                if (drawing != null && drawing.length != 0) {
                    drawing[0].previews = [];
                    vm.$timeout(() => {
                        for (var md of data) {
                            drawing[0].previews = drawing[0].previews.concat(md.previews);
                        }
                        vm.selectedMainDrawing = null;
                    });
                }
                vm.$mdDialog.cancel();
            }, () => {
                vm.$mdDialog.cancel();
                vm.selectedMainDrawing = null;
            });
        }

        public deleteImage(md: MainDrawingViewModel, drawing: DrawingViewModel) {
            var vm = this;
            var dwfName = drawing.mainDrawingUrl.substring(drawing.mainDrawingUrl.lastIndexOf('/') + 1);
            var confirm = this.$mdDialog.confirm()
                .title(vm.textService.translate('ScannedImage_DeleteDrawing'))
                .textContent(vm.textService.translate('ScannedImage_DeleteConfirmation').replace(/\{0\}/g, dwfName))
                .ariaLabel(vm.textService.translate('ScannedImage_DeleteDrawing'))
                .ok(vm.textService.translate('Button_OK'))
                .cancel(vm.textService.translate('Button_Cancel'));

            this.$mdDialog.show(confirm).then(() => {
                vm.mainDrawingService.delete(md.associationNumber, md.departmentNumber, md.localizer, dwfName).then((data: MainDrawingViewModel[]) => {
                    md.previews = [];
                    vm.$timeout(() => {
                        for (var d of data) {
                            md.previews = md.previews.concat(d.previews);
                        }
                    });
                }, () => {
                });
            }, () => { });
        }

        public downloadZip(association: string, department: string, localizer: string) {
            this.showSpinner();
            var vm = this;
            this.mainDrawingService.getArchive(association, department, localizer).then((data) => {
                var name = 'maindrawing-' + localizer + '.zip';
                if (data != null && navigator.msSaveBlob)
                    return navigator.msSaveBlob(new Blob([data], { type: 'application/octet-stream' }), name);
                var a = $("<a style='display: none;' target='_blank'/>");
                var url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }));
                a.attr("href", url);
                a.attr("download", name);
                $("body").append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
                vm.$mdDialog.cancel();
            }, () => {
                vm.$mdDialog.cancel();
            });
        }

        public showSpinner() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/spinner.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false
            };
            this.$mdDialog.show(dialog);
            return dialog;
        }

        public static WarningDialogController = (fileId: string, textService: TextService, fileService: FileService, $mdDialog: any) => {
            return function () {
                this.fileId = fileId;
                this.errors = null;
                this.pageNumber = 0;
                this.loading = false;
                this.isLastPage = false;
                this.$mdDialog = $mdDialog;
                var self = this;
                fileService.getDrawingExportErrors(fileId, this.pageNumber).then((data: UploadingErrorPagedResult) => {
                    self.errors = data;
                    self.isLastPage = data == null || data.results == null || data.results.length < 10;
                })
                this.closeAndProceed = function () {
                    return true;
                };
                this.getDialogHeader = function () {
                    if (self.errors != null && self.errors.results != null && self.errors.results.length > 0) {
                        return self.errors.totalNumberOfRecords + ' ' + textService.translate('WarningList_ErrorsAndWarnings');
                    }
                }
                this.hasErrors = function () {
                    return true;
                }
                this.onListScroll = function (sender) {
                    if (!self.loading && !self.isLastPage && $(sender).scrollTop() + $(sender)[0].clientHeight > $(sender).filter('.error-list').height() - 80) {
                        self.loading = true;
                        self.pageNumber++;
                        self.fileService.getFileErrors(self.fileId, self.pageNumber).then((data: UploadingErrorPagedResult) => {
                            if (self.errors != null && self.errors.results != null && data.results.length > 0) {
                                self.errors.results = self.errors.results.concat(data.results);
                            }
                            self.isLastPage = data == null || data.results == null || data.results.length < 10;
                            self.loading = false;
                        }, () => {
                            self.loading = false;
                        });
                    }
                }
            }
        }
    }

    MainDrawingController.$inject = ['$scope', 'BuildingService', 'MainDrawingService', 'DrawingExportJobService', '$q', '$timeout', '$mdDialog', 'FileService', 'TextService'];

    angular
        .module('eseebase')
        .controller('MainDrawingController', MainDrawingController);
}
